"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FilterPill = exports.CollapsedFilterPill = void 0;
var _react = require("react");
var _utils = require("@design/lib/utils");
var _toggle = require("@design/ui/toggle");
var _jsxRuntime = require("react/jsx-runtime");
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
var FilterPill = exports.FilterPill = function FilterPill(_ref) {
  var button = _ref.button,
    isActive = _ref.isActive,
    onClick = _ref.onClick;
  var _useState = (0, _react.useState)(false),
    _useState2 = _slicedToArray(_useState, 2),
    isHovered = _useState2[0],
    setIsHovered = _useState2[1];
  var showLabel = isActive || isHovered;
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_toggle.Toggle, {
    variant: "outline",
    size: "sm",
    pressed: isActive,
    className: "shrink-0",
    onClick: onClick,
    title: button.label,
    onMouseEnter: function onMouseEnter() {
      return setIsHovered(true);
    },
    onMouseLeave: function onMouseLeave() {
      return setIsHovered(false);
    },
    "data-sentry-element": "Toggle",
    "data-sentry-component": "FilterPill",
    "data-sentry-source-file": "filter-pill-bar.tsx",
    children: [button.icon, /*#__PURE__*/(0, _jsxRuntime.jsx)(FilterPillLabel, {
      label: button.label,
      isShown: showLabel,
      "data-sentry-element": "FilterPillLabel",
      "data-sentry-source-file": "filter-pill-bar.tsx"
    })]
  });
};
var FilterPillLabel = function FilterPillLabel(_ref2) {
  var label = _ref2.label,
    isShown = _ref2.isShown;
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
    className: (0, _utils.cn)("grid transition-[grid-template-columns,opacity] duration-200 ease-out", isShown ? "grid-cols-[1fr] opacity-100" : "grid-cols-[0fr] opacity-0"),
    "data-sentry-component": "FilterPillLabel",
    "data-sentry-source-file": "filter-pill-bar.tsx",
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
      className: "min-w-0 overflow-hidden whitespace-nowrap leading-none",
      children: label
    })
  });
};
var CollapsedFilterPill = exports.CollapsedFilterPill = function CollapsedFilterPill(_ref3) {
  var button = _ref3.button,
    onClick = _ref3.onClick;
  var _useState3 = (0, _react.useState)(false),
    _useState4 = _slicedToArray(_useState3, 2),
    isHovered = _useState4[0],
    setIsHovered = _useState4[1];
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_toggle.Toggle, {
    variant: "outline",
    size: "sm",
    pressed: true,
    className: "shrink-0",
    onClick: onClick,
    title: button.label,
    onMouseEnter: function onMouseEnter() {
      return setIsHovered(true);
    },
    onMouseLeave: function onMouseLeave() {
      return setIsHovered(false);
    },
    "data-sentry-element": "Toggle",
    "data-sentry-component": "CollapsedFilterPill",
    "data-sentry-source-file": "filter-pill-bar.tsx",
    children: [button.icon, /*#__PURE__*/(0, _jsxRuntime.jsx)(FilterPillLabel, {
      label: button.label,
      isShown: isHovered,
      "data-sentry-element": "FilterPillLabel",
      "data-sentry-source-file": "filter-pill-bar.tsx"
    })]
  });
};